module.exports = __webpack_public_path__ + "static/media/metereologia.0c57ab3a.svg";